import { render } from "./CASIChoiceInput.vue?vue&type=template&id=0eecfc3e&scoped=true"
import script from "./CASIChoiceInput.vue?vue&type=script&lang=js"
export * from "./CASIChoiceInput.vue?vue&type=script&lang=js"

import "./CASIChoiceInput.vue?vue&type=style&index=0&id=0eecfc3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eecfc3e"]])

export default __exports__